import React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { OverseasCompanyData } from '../../../../../types/api'
import { Card } from 'plume-ui'
import { CardTitle } from '../../../../atoms/CardTitle'
import { DoubleColumnContent } from './DoubleColumnContent'
import { DescriptionList } from '../../../../atoms/DescriptionList'
import { formatDate } from '@/lib/date'
import { toUnitNumber } from '@/lib/number'
import { OverviewAmountWithCurrency } from './OverviewAmountWithCurrency'
import { FinanceInfoItem } from './FinanceInfoItem'
import { DatasourceLink } from '../DatasourceLink'

type Props = {
  company: OverseasCompanyData
}

export const OverseasCompanyOverview: React.VFC<Props> = ({ company }) => {
  return (
    <div className="overview">
      <CardTitle
        right={
          <DatasourceLink
            href="https://help.initial.inc/ja/articles/5358443"
            className="about-data-source"
          />
        }
      >
        企業概要
      </CardTitle>
      <Card>
        <DoubleColumnContent>
          <DescriptionList
            list={{
              '国・地域': {
                text: company.country || '',
                extraClassName: 'country',
              },
            }}
          />
          <DescriptionList
            className="company-type"
            list={{
              タイプ: { text: '未公開企業', extraClassName: 'type' },
            }}
          />
        </DoubleColumnContent>
      </Card>
      <Card
        css={css`
          border-top: 1px solid ${colors.border};
          border-bottom: 1px solid ${colors.border};
        `}
      >
        <div
          css={css`
            display: flex;
            padding: 32px;
            justify-content: space-between;
          `}
        >
          <FinanceInfoItem
            className="total-funding"
            label={'総調達額'}
            value={
              <OverviewAmountWithCurrency
                amount={
                  company.totalFundraise
                    ? toUnitNumber(company.totalFundraise.value)
                    : null
                }
                currency={
                  company.totalFundraise ? company.totalFundraise.currency : ''
                }
              />
            }
            valueAnnotationDesc="最新対象ラウンド"
            valueAnnotationDate={
              company.totalFundraise && company.totalFundraise?.date
                ? formatDate(company.totalFundraise.date, 'yyyy/MM/dd')
                : null
            }
          />
        </div>
      </Card>
    </div>
  )
}
